/* eslint-disable no-console */

import Raven from "raven-js";

import {
  RAVEN_DSN,
  ENABLE_SENTRY_REPORTING,
  GIT_COMMIT,
  ENVIRONMENT,
} from "config/constants";

export default class Log {
  static setup() {
    if (ENABLE_SENTRY_REPORTING && !Raven.isSetup()) {
      Raven.config(RAVEN_DSN, {
        environment: ENVIRONMENT,
        release: GIT_COMMIT,
        ignoreErrors: [
          "ResizeObserver loop limit exceeded", // thrown by react-measure, harmless
        ],
      }).install();
    }
  }

  /**
   * Log an error to Sentry
   * @param {*} msg - Error message or instance
   * @param {String} level - severity
   * @param {Object} extra - supplemental data to pass to Raven
   * @param {Boolean} toConsole - true if this error should be logged to the console as well.
   * @param {Array<String>} fingerprint - see https://docs.sentry.io/learn/rollups/#customize-grouping-with-fingerprints
   */
  static logger(msg, level, extra, toConsole = true, fingerprint) {
    if (ENABLE_SENTRY_REPORTING) {
      this.setup();
      Raven.captureException(msg, {
        level,
        fingerprint,
        extra: {
          ...extra,
          ...msg.context, // API errors return a special kind of error with lots of context
        },
      });
    }

    if (toConsole) {
      switch (level) {
        case "error":
          console.error(msg);
          break;
        case "warning":
          console.warn(msg);
          break;
        default:
          console.log(msg);
      }
    }
  }

  static error(err) {
    this.logger(err, "error");
  }

  static warn(msg) {
    this.logger(msg, "warning");
  }

  static log(msg) {
    this.logger(msg, "info");
  }

  static context(fn) {
    if (ENABLE_SENTRY_REPORTING) {
      this.setup();
      return Raven.context(fn);
    }
  }
}
